import { render } from "./flootNav.vue?vue&type=template&id=04dac84f&scoped=true"
import script from "./flootNav.vue?vue&type=script&lang=js"
export * from "./flootNav.vue?vue&type=script&lang=js"

import "./flootNav.vue?vue&type=style&index=0&id=04dac84f&lang=less&scoped=scoped"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dac84f"]])

export default __exports__